<script setup>
import {onBeforeUnmount, onMounted, ref,} from "vue"

const describedByPlainText = ref('')
let clearMessageTimeoutId = null

const clearMessage = () => {
    if (clearMessageTimeoutId !== null) {
        clearTimeout(clearMessageTimeoutId)
    }

    clearMessageTimeoutId = setTimeout(() => {
        describedByPlainText.value = ''
        clearMessageTimeoutId = null
    }, 2000)
}

const handleEnter = function (event) {
    if ((event.key === 'Enter' || event.keyCode === 13)
        && event?.target?.hasAttribute('aria-describedby')
        && event.target.tagName !== 'INPUT'
        && event.target.tagName !== 'TEXTAREA'
        && !event.target.classList.contains('ck-content')) {
        let id = event?.target?.getAttribute('aria-describedby')
        describedByPlainText.value = document?.getElementById(id)?.textContent
        clearMessage()
    }
}

onMounted(() => {
    document.addEventListener('keydown', handleEnter)
})
onBeforeUnmount( ()=> {
    document.removeEventListener('keydown', handleEnter)
})
</script>

<template>
    <div
        aria-live="polite"
        aria-atomic="true"
        class="d-sr-only"
    >
        {{ describedByPlainText }}
    </div>
</template>
